import { ExperimentOutlined } from '@ant-design/icons'
import { Stack } from '@sureco/design-system'
import { Button } from '@surecompanies/core_components'
import { RouterContextProvider } from 'components/RouterContext'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import useWindowDimensions from 'hooks/useWindowDimensions'
import Page from 'layouts/Page'
import React, { useRef } from 'react'
import { browserHistory } from 'react-router'
import { DEMO_COMPANY_MANAGEMENT, demoCompanyViewPath } from '../paths'
import DemoBanner from './components/DemoBanner'
import DemoCustomerCreateForm, {
  DemoFormRef,
} from './components/DemoCustomerCreateForm'
import DemoPresetsModal from './components/DemoPresetsModal'
import { DemoCustomerStep1Data } from './demoCustomer.schema'
import useCreateDemoCustomer from './hooks/useCreateDemoCustomer'

export default function DemoCustomer() {
  const { width } = useWindowDimensions()
  const buttonSize = width > 600 ? 'middle' : 'large'
  const formRef = useRef<DemoFormRef>(null)
  const { mutateAsync, isPending } = useCreateDemoCustomer()

  const handleSubmit = async (data: DemoCustomerStep1Data) => {
    try {
      const response = await mutateAsync(data)
      browserHistory.push(`/${demoCompanyViewPath(response.id)}`)
    } catch {
      // Error notification handled inside useCreateDemoCustomer
    }
  }

  return (
    <RouterContextProvider>
      <Page
        title="New Demo Company"
        breadcrumb={
          <BreadcrumbNav
            items={[
              { title: 'Demo Companies', path: `/${DEMO_COMPANY_MANAGEMENT}` },
              { title: 'New Demo Company' },
            ]}
          />
        }
        action={
          <Stack direction="row" space={10}>
            <Button
              type="default"
              size={buttonSize}
              disabled={isPending}
              onClick={() => browserHistory.push(`/${DEMO_COMPANY_MANAGEMENT}`)}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              size={buttonSize}
              loading={isPending}
              icon={<ExperimentOutlined />}
              onClick={() => formRef.current?.submit()}
            >
              Create Demo Company
            </Button>
          </Stack>
        }
      >
        <Stack space={24}>
          <DemoBanner />
          <DemoCustomerCreateForm ref={formRef} onSubmit={handleSubmit} />
          <DemoPresetsModal />
        </Stack>
      </Page>
    </RouterContextProvider>
  )
}
